module.exports = __webpack_public_path__ + "static/media/glass_clean.107fbd45.jpg";